import { render, staticRenderFns } from "./blog-archive.vue?vue&type=template&id=fbb30f4c&scoped=true&lang=pug"
import script from "./blog-archive.vue?vue&type=script&lang=ts"
export * from "./blog-archive.vue?vue&type=script&lang=ts"
import style0 from "./blog-archive.vue?vue&type=style&index=0&id=fbb30f4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb30f4c",
  null
  
)

export default component.exports